
import {fetchParam} from '../settings/settings';

$('body').on('click', '.js-load-more-messages', (e) => {
  const $button = $(e.target);
  fetch($button.data('url'), fetchParam)
    .then(response => {
      if (response.ok && response.status === 200) {
        return response.json();
      }
    })
    .then(data => {
      $button.before(data);
      $button.remove();
    })
  ;
});
